import { createEvent, restore, sample } from 'effector'
import { AddTicketsRequest } from './types'
import { fx } from '../../../../../libs'
import { RequestError } from '../../../../../shared/errorResponse'

export const addTicketsSubmit = createEvent<AddTicketsRequest>()

export const setError = createEvent<RequestError>()

export const setIsAddTicketsSuccess = createEvent<boolean>()

export const $isAddTicketsSuccess = restore(setIsAddTicketsSuccess, false)

export const $error = restore(setError, {
  message: '',
  code: 0,
})

export const addTickets = fx<AddTicketsRequest, void>({
  method: 'POST',
  url: `/promo/new_year_2026/tickets/reserve`,
})

sample({
  // @ts-ignore
  clock: addTicketsSubmit,
  fn: ({ ticketID, userID }) => {
    return {
      url: `/promo/new_year_2026/tickets/reserve`,
      body: {
        ticketID,
        userID,
      },
    }
  },
  target: addTickets,
})

sample({
  clock: addTickets.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

sample({
  clock: addTickets.doneData,
  fn: () => {
    return true
  },
  target: setIsAddTicketsSuccess,
})
